export const keyboardEventsKey = {
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
};
export const KeyboardDirectionsConst = [
    keyboardEventsKey.ARROW_UP,
    keyboardEventsKey.ARROW_DOWN,
    keyboardEventsKey.ARROW_LEFT,
    keyboardEventsKey.ARROW_RIGHT,
];
export const ListDirections = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
const ListDirectionsConst = [
    ListDirections.HORIZONTAL,
    ListDirections.VERTICAL,
];
export var NullStateSuggestionTypes;
(function (NullStateSuggestionTypes) {
    NullStateSuggestionTypes["latestCollections"] = "latestCollections";
    NullStateSuggestionTypes["trendingCollections"] = "trendingCollections";
})(NullStateSuggestionTypes || (NullStateSuggestionTypes = {}));
export const suggestionTypesKey = {
    KEYWORDS: 'keywords',
    WITHIN_ASSET: 'withinAssetContentTypeSuggestions',
    RELATED_CONTENT_TYPE: 'relatedContentTypeSuggestion',
    RELATED_COLLECTION: 'relatedCollections',
    SUGGESTED_PAGES: 'suggestedPages',
};
const SuggestionTypesConst = [
    suggestionTypesKey.KEYWORDS,
    suggestionTypesKey.WITHIN_ASSET,
    suggestionTypesKey.RELATED_CONTENT_TYPE,
    suggestionTypesKey.RELATED_COLLECTION,
    suggestionTypesKey.SUGGESTED_PAGES,
];
